import { sbaAxios } from "../utils/sbaAxios";
import { getTaskTypes, getTasks, getTaskAssignees, getTaskDetails, getTaskDocuments, getTaskViewSettings, getActivityTaskViewSelect, getTaskViewColums, getAvailableTaskViewColumns } from "../../config/apiConfig";
import {
    FETCH_TASKTYPE_BEGIN,
    FETCH_TASKTYPE_SUCCESS,
    FETCH_TASKTYPE_FAILURE,
    FETCH_TASKS_BEGIN,
    FETCH_TASKS_SUCCESS,
    FETCH_TASKS_FAILURE,
    FETCH_TASKASSIGNEE_BEGIN,
    FETCH_TASKASSIGNEE_SUCCESS,
    FETCH_TASKASSIGNEE_FAILURE,
    FETCH_TASKDETAILS_BEGIN,
    FETCH_TASKDETAILS_SUCCESS,
    FETCH_TASKDETAILS_FAILURE,
    FETCH_TASKDOCUMENTS_BEGIN,
    FETCH_TASKDOCUMENTS_SUCCESS,
    FETCH_TASKDOCUMENTS_FAILURE,
    FETCH_TASKSETTINGVIEW_BEGIN,
    FETCH_TASKSETTINGVIEW_SUCCESS,
    FETCH_TASKSETTINGVIEW_FAILURE, 
    FETCH_TASKVIEW_BEGIN,
    FETCH_TASKVIEW_SUCCESS,
    FETCH_TASKVIEW_FAILURE, 
    FETCH_TASKVIEWCOLUMN_BEGIN,
    FETCH_TASKVIEWCOLUMN_SUCCESS,
    FETCH_TASKVIEWCOLUMN_FAILURE,

    FETCH_TASKVIEWCOLUMNBYVIEWID_BEGIN,
    FETCH_TASKVIEWCOLUMNBYVIEWID_SUCCESS,
    FETCH_TASKVIEWCOLUMNBYVIEWID_FAILURE,
  } from '../constants/tasks';

// Get Task Types
export const getTaskTypesAction=()=>{ 
    return async (dispatch) => {
      dispatch(getTaskTypesActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getTaskTypes}`,
                method: 'get',
            })
          const TaskType = response;
          dispatch(getTaskTypesActionSuccess(TaskType));
        } catch (error) {
          if (error.message === 'Network Error') {
            dispatch(getTaskTypesActionSuccess({}));
          } else {
            dispatch(getTaskTypesActionFailure(error));
          }
        }
    };
  }
  
  export const getTaskTypesActionBegin = () => ({
      type: FETCH_TASKTYPE_BEGIN,
    });
    
    export const getTaskTypesActionSuccess = (taskType) => ({
      type: FETCH_TASKTYPE_SUCCESS,
      payload: {taskType},
    });
  
    export const getTaskTypesActionFailure = (errorMessage) => ({
        type: FETCH_TASKTYPE_FAILURE,
        payload: {errorMessage}
      });
      
      // Get Tasks
export const getTasksAction=(startDate,endDate,taskTypeIds)=>{ 
    return async (dispatch) => {
      dispatch(getTasksActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getTasks}?startDate=${startDate}&endDate=${endDate}&taskTypeIds=${taskTypeIds}`,
                method: 'get',
            })
          const Tasks = response;
          dispatch(getTasksActionSuccess(Tasks));
        } catch (error) {
          if (error.message === 'Network Error') {
            dispatch(getTasksActionSuccess({}));
          } else {
            dispatch(getTasksActionFailure(error));
          }
        }
    };
  }
  
  export const getTasksActionBegin = () => ({
      type: FETCH_TASKS_BEGIN,
    });
    
    export const getTasksActionSuccess = (tasks) => ({
      type: FETCH_TASKS_SUCCESS,
      payload: {tasks},
    });
  
    export const getTasksActionFailure = (errorMessage) => ({
        type: FETCH_TASKS_FAILURE,
        payload: {errorMessage}
      });

            // Get TaskAssignee
export const getTaskAssigneeAction=()=>{ 
    return async (dispatch) => {
      dispatch(getTaskAssigneeActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getTaskAssignees}`,
                method: 'get',
            })
          const TaskAssignee = response;
          dispatch(getTaskAssigneeActionSuccess(TaskAssignee));
        } catch (error) {
          if (error.message === 'Network Error') {
            dispatch(getTaskAssigneeActionSuccess({}));
          } else {
            dispatch(getTaskAssigneeActionFailure(error));
          }
        }
    };
  }
  
  export const getTaskAssigneeActionBegin = () => ({
      type: FETCH_TASKASSIGNEE_BEGIN,
    });
    
    export const getTaskAssigneeActionSuccess = (taskAssignee) => ({
      type: FETCH_TASKASSIGNEE_SUCCESS,
      payload: {taskAssignee},
    });
  
    export const getTaskAssigneeActionFailure = (errorMessage) => ({
        type: FETCH_TASKASSIGNEE_FAILURE,
        payload: {errorMessage}
      });


                  // Get TaskDetails
export const getTaskDetailsAction=(ActivityId)=>{ 
    return async (dispatch) => {
      dispatch(getTaskAssigneeActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getTaskDetails}${ActivityId}`,
                method: 'get',
            })
          const TaxDetails = response;
          dispatch(getTaskDetailsActionSuccess(TaxDetails));
        } catch (error) {
          if (error.message === 'Network Error') {
            dispatch(getTaskDetailsActionSuccess({}));
          } else {
            dispatch(getTaskDetailsActionFailure(error));
          }
        }
    };
  }
  
  export const getTaskDetailsActionBegin = () => ({
      type: FETCH_TASKDETAILS_BEGIN,
    });
    
    export const getTaskDetailsActionSuccess = (taskDetails) => ({
      type: FETCH_TASKDETAILS_SUCCESS,
      payload: {taskDetails},
    });
  
    export const getTaskDetailsActionFailure = (errorMessage) => ({
        type: FETCH_TASKDETAILS_FAILURE,
        payload: {errorMessage}
      });


                        // Get TaskDocuments
export const getTaskDocumentsAction=(ActivityId)=>{ 
    return async (dispatch) => {
      dispatch(getTaskDocumentsActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getTaskDocuments}${ActivityId}`,
                method: 'get',
            })
          const doc = response;
          dispatch(getTaskDocumentsActionSuccess(doc));
        } catch (error) {
          if (error.message === 'Network Error') {
            dispatch(getTaskDocumentsActionSuccess({}));
          } else {
            dispatch(getTaskDocumentsActionFailure(error));
          }
        }
    };
  }
  
  export const getTaskDocumentsActionBegin = () => ({
      type: FETCH_TASKDOCUMENTS_BEGIN,
    });
    
    export const getTaskDocumentsActionSuccess = (taskDocuments) => ({
      type: FETCH_TASKDOCUMENTS_SUCCESS,
      payload: {taskDocuments},
    });
  
    export const getTaskDocumentsActionFailure = (errorMessage) => ({
        type: FETCH_TASKDOCUMENTS_FAILURE,
        payload: {errorMessage}
});

//Task setting view 
export const getTaskViewSettingsAction = (TaskViewId, GetAllSettings ) => {
    return async (dispatch) => {
        dispatch(getTaskViewSettingsActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getTaskViewSettings}${TaskViewId},${GetAllSettings}`,
                method: 'get',
            })
            const TaskViewSettings = response;
            dispatch(getTaskViewSettingsActionSuccess(TaskViewSettings));
        } catch (error) {
            if (error.message === 'Network Error') {
                dispatch(getTaskViewSettingsActionSuccess({}));
            } else {
                dispatch(getTaskViewSettingsActionFailure(error));
            }
        }
    };
}

export const getTaskViewSettingsActionBegin = () => ({
    type: FETCH_TASKSETTINGVIEW_BEGIN,
});

export const getTaskViewSettingsActionSuccess = (TaskViewSettings) => ({
    type: FETCH_TASKSETTINGVIEW_SUCCESS,
    payload: { TaskViewSettings },
});

export const getTaskViewSettingsActionFailure = (errorMessage) => ({
    type: FETCH_TASKSETTINGVIEW_FAILURE,
    payload: { errorMessage }
});



export const getActivityTaskViewSelectAction = () => {
    return async (dispatch) => {
        dispatch(getActivityTaskViewSelectActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getActivityTaskViewSelect}`,
                method: 'get',
            })
   const ActivityTaskView = [{"TaskViewId":-1,"TaskViewName":"Please Select"}, ...response];
            dispatch(getActivityTaskViewSelectActionSuccess(ActivityTaskView));
        } catch (error) {
            if (error.message === 'Network Error') {
                dispatch(getActivityTaskViewSelectActionSuccess({}));
            } else {
                dispatch(getActivityTaskViewSelectActionFailure(error));
            }
        }
    };
}

export const getActivityTaskViewSelectActionBegin = () => ({
    type: FETCH_TASKVIEW_BEGIN,
});

export const getActivityTaskViewSelectActionSuccess = (ActivityTaskView) => ({
    type: FETCH_TASKVIEW_SUCCESS,
    payload: { ActivityTaskView },
});

export const getActivityTaskViewSelectActionFailure = (errorMessage) => ({
    type: FETCH_TASKVIEW_FAILURE,
    payload: { errorMessage }
});

// Tasks View Columns.....

export const getActivityTaskViewColumnAction = (ViewId) => {
  return async (dispatch) => {
      dispatch(getActivityTaskViewColumnActionBegin());
      try {
          const response = await sbaAxios({
              url: `${getTaskViewColums}${ViewId}`,
              method: 'get',
          })    
          const ActivityTaskView = response;
          dispatch(getActivityTaskViewColumnActionSuccess(ActivityTaskView));
      } catch (error) {
          if (error.message === 'Network Error') {
              dispatch(getActivityTaskViewColumnActionSuccess({}));
          } else {
              dispatch(getActivityTaskViewColumnActionFailure(error));
          }
      }
  };
}
export const getActivityTaskViewColumnActionBegin = () => ({
  type: FETCH_TASKVIEWCOLUMN_BEGIN,
});
export const getActivityTaskViewColumnActionSuccess = (taskviewColumns) => ({
  type: FETCH_TASKVIEWCOLUMN_SUCCESS,
  payload: { taskviewColumns },
});
export const getActivityTaskViewColumnActionFailure = (errorMessage) => ({
  type: FETCH_TASKVIEWCOLUMN_FAILURE,
  payload: { errorMessage }
});
export const getAvailableTaskViewColumnsAction = (TaskViewId) => {
  
    return async (dispatch) => {
      dispatch(getAvailableTaskViewColumnsActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getAvailableTaskViewColumns}${TaskViewId}`,
                method: 'get',
            })
            const AvailableTaskViewColumns = response;
            dispatch(getAvailableTaskViewColumnsActionSuccess(AvailableTaskViewColumns));
        } catch (error) {
          if (error.message === 'Network Error') {
            dispatch(getAvailableTaskViewColumnsActionSuccess({}));
          } else {
            dispatch(getAvailableTaskViewColumnsActionFailure(error));
          }
        }
    };
}

export const getAvailableTaskViewColumnsActionBegin = () => ({
    type: FETCH_TASKVIEWCOLUMNBYVIEWID_BEGIN,
});

export const getAvailableTaskViewColumnsActionSuccess = (AvailableTaskViewColumns) => ({
    type: FETCH_TASKVIEWCOLUMNBYVIEWID_SUCCESS,
    payload: { AvailableTaskViewColumns },
});

export const getAvailableTaskViewColumnsActionFailure = (errorMessage) => ({
    type: FETCH_TASKVIEWCOLUMNBYVIEWID_FAILURE,
    payload: { errorMessage }
});